(() => {
  if (window.__grundpreisUpdaterLoaded) return;
  window.__grundpreisUpdaterLoaded = true;

  const cache = new Map();
  const stateByScope = new WeakMap();

  const parseVariantId = (val) => {
    const n = Number(String(val || '').trim());
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  const isVisible = (el) => !!(el && (el.offsetParent !== null || el.getClientRects().length));

  const findBestVariantIdControl = (root) => {
    // 1) bevorzugt: Add-to-cart Form, aber NICHT payment-terms
    const forms = Array.from(root.querySelectorAll('form[action*="/cart/add"]'))
      .filter((f) => !f.classList.contains('payment-terms') && !f.closest('.payment-terms'));

    // Fallback: falls nichts gefunden, nimm alle cart/add forms
    const allForms = forms.length ? forms : Array.from(root.querySelectorAll('form[action*="/cart/add"]'));

    const controls = [];
    for (const form of allForms) {
      const c = form.querySelector('input[name="id"], select[name="id"]');
      if (c) controls.push(c);
    }

    // 2) wenn mehrere: nimm sichtbaren
    const visible = controls.find(isVisible);
    return visible || controls[0] || null;
  };

  const getVariantId = (scope, eventTarget) => {
    // A) vom Event aus: nächstes Add-to-cart Formular suchen
    const nearRoot =
      eventTarget?.closest?.('.shopify-section') ||
      eventTarget?.closest?.('section') ||
      scope;

    let control = findBestVariantIdControl(nearRoot);

    // B) im Scope suchen
    if (!control) control = findBestVariantIdControl(scope);

    // C) globaler Fallback (Produktseite hat id meist nur 1x)
    if (!control) control = findBestVariantIdControl(document);

    if (control) return parseVariantId(control.value);

    // D) letzter Fallback: URL ?variant=
    return parseVariantId(new URLSearchParams(location.search).get('variant'));
  };

  const fetchSectionMarkup = async (sectionId, variantId) => {
    const key = `${sectionId}|${variantId}`;
    if (cache.has(key)) return cache.get(key);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));

    // Erst versuchen: sections= (JSON)
    const urlJson = new URL(url.toString());
    urlJson.searchParams.set('sections', String(sectionId));

    const p = fetch(urlJson.toString(), { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((txt) => {
        try {
          const json = JSON.parse(txt);
          if (json && json[sectionId]) return { type: 'json', html: json[sectionId] };
        } catch (_) {}
        return { type: 'text', html: txt };
      })
      .then(async (res) => {
        // Wenn JSON nicht ging/kein Treffer: klassisch section_id= (HTML)
        if (res.type === 'json') return res.html;

        const urlHtml = new URL(url.toString());
        urlHtml.searchParams.set('section_id', String(sectionId));
        const html = await fetch(urlHtml.toString(), { credentials: 'same-origin' })
          .then((r) => r.text())
          .catch(() => '');
        return html;
      })
      .catch(() => '');

    cache.set(key, p);
    return p;
  };

  const updateGrundpreisInScope = async (scope, variantId) => {
    const wrappers = scope.querySelectorAll('[data-grundpreis][data-section-id][data-block-id]');
    if (!wrappers.length) return;

    // pro section nur 1 fetch
    const bySection = new Map();
    wrappers.forEach((el) => {
      const sid = el.getAttribute('data-section-id');
      if (!bySection.has(sid)) bySection.set(sid, []);
      bySection.get(sid).push(el);
    });

    for (const [sid, els] of bySection.entries()) {
      const html = await fetchSectionMarkup(sid, variantId);
      if (!html) continue;

      const doc = new DOMParser().parseFromString(html, 'text/html');

      els.forEach((oldEl) => {
        const bid = oldEl.getAttribute('data-block-id');
        const fresh = doc.querySelector(`#Grundpreis-${CSS.escape(sid)}-${CSS.escape(bid)}`);

        oldEl.innerHTML = fresh ? fresh.innerHTML : '';

        // Debug/Proof: du kannst diese Attribute in DevTools beobachten
        oldEl.setAttribute('data-grundpreis-last-variant', String(variantId));
        oldEl.setAttribute('data-grundpreis-updated-at', String(Date.now()));
      });
    }
  };

  const runForScope = async (scope, eventTarget) => {
    const variantId = getVariantId(scope, eventTarget);
    if (!variantId) return;

    const last = stateByScope.get(scope);
    if (last === variantId) return;

    stateByScope.set(scope, variantId);
    await updateGrundpreisInScope(scope, variantId);
  };

  // Event-Hooks (wenn vorhanden)
  const schedule = (e) => {
    const target = e.target;
    const scope = target?.closest?.('.shopify-section') || document;

    // Themes updaten Variant oft async -> kurze Verzögerung
    setTimeout(() => runForScope(scope, target), 120);
    setTimeout(() => runForScope(scope, target), 420);
  };

  document.addEventListener('variant:change', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  document.addEventListener('click', schedule, true);

  // Polling (funktioniert auch ohne Events/URL-Update)
  setInterval(() => {
    document.querySelectorAll('[data-grundpreis]').forEach((el) => {
      const scope = el.closest('.shopify-section') || document;
      runForScope(scope, el);
    });
  }, 250);
})();
